import fetchAbhaQr from '../../api/fetchAbhaQr';
import { captureError } from '../../pages/captureError';
import { track } from '../../tracking';

export const fetchAndDownloadAbhaQrController = async (clinicId: string) => {
    track('ABHA_QR_DOWNLOAD', { clinicId });

    try {
        const response = await fetchAbhaQr(clinicId);
        const uint8Array = new Uint8Array(response);
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(blob);

        const downloadLink = document.createElement('a');
        downloadLink.href = pdfUrl;
        downloadLink.download = 'abha_qr_code.pdf';

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    } catch (error) {
        captureError(error as Error);
        throw error;
    }
};
